// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"850":"ee45d65c","890":"517b6502"}[chunkId] + ".chunk.css";
};